import * as React from "react"
import type { IconProps } from "../types"
const Meta = React.forwardRef<SVGSVGElement, Omit<IconProps, "color">>(
  (props, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={15}
        height={15}
        fill="none"
        ref={ref}
        {...props}
      >
        <g clipPath="url(#a)">
          <path
            fill="#0467DF"
            d="M4.322 2.519c-1.23 0-2.302.8-3.044 1.946C.44 5.755 0 7.427 0 9.03c0 .441.044.855.131 1.233q.065.274.166.537.097.248.232.476c.435.724 1.136 1.204 2.245 1.204.936 0 1.646-.419 2.479-1.527.474-.633.715-1.016 1.664-2.7l.472-.837.117-.203.114.187 1.345 2.247c.453.757 1.04 1.598 1.544 2.072.653.616 1.245.762 1.912.762.672 0 1.173-.222 1.535-.527a2.3 2.3 0 0 0 .506-.608c.339-.587.538-1.33.538-2.34 0-1.7-.426-3.349-1.303-4.657-.8-1.195-1.848-1.831-2.947-1.831-.654 0-1.305.292-1.908.817-.408.357-.786.807-1.138 1.282-.43-.547-.834-.967-1.223-1.285-.74-.604-1.447-.815-2.16-.815m6.35 1.283c.717 0 1.367.474 1.87 1.25.707 1.092 1.03 2.621 1.03 4 0 .967-.23 1.812-1.15 1.812-.363 0-.642-.144-1.04-.628-.31-.375-.84-1.173-1.77-2.723l-.386-.643q-.376-.63-.784-1.237c.044-.068.088-.14.132-.205.7-1.042 1.323-1.626 2.098-1.626m-6.376.346c.79 0 1.286.494 1.672.903.192.205.46.545.771.987l-.637.98c-.473.726-1.176 1.885-1.773 2.71-.745 1.03-1.131 1.136-1.554 1.136a.99.99 0 0 1-.864-.496c-.165-.267-.29-.707-.29-1.28 0-1.387.393-2.833 1.037-3.804.284-.43.603-.766.958-.958.208-.116.442-.177.68-.178"
          />
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#fff" d="M0 0h15v15H0z" />
          </clipPath>
        </defs>
      </svg>
    )
  }
)
Meta.displayName = "Meta"
export default Meta
